import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeroSectionComponent } from './components/hero-section/hero-section.component';
import { GrantsListComponent } from './components/grants-list/grants-list.component';

@Component({
    selector: 'app-miti-grants',
    standalone: true,
    imports: [
        HeaderComponent,
        FooterComponent,
        HeroSectionComponent,
        GrantsListComponent,
    ],
    templateUrl: './miti-grants.component.html',
    styleUrl: './miti-grants.component.scss',
})
export class MitiGrantsComponent implements OnInit {
    selectedLanguage: any;

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }
}
